/**
 * Pronto Posto – Maildaten · Englisch (en-GB / EN-UK) · KS03
 *
 * KS03 Traumschiff – Petra Whitfield / Rafaela Silva. Postfach: rafaela-silva@pronto-posto.com
 *
 * Aufteilung nach language/episode: geteilte Inhalte einer Sprache leben in ./_shared.js.
 * Sprachen sind strikt getrennt – Mails dieser Datei adressieren ausschliesslich Postfaecher
 * dieser Sprache. IDs sind global eindeutig (siehe ID-Reservierungen in den Blockkommentaren).
 */
/* eslint-disable */

export function getEmails() {
    return [
        // KS03 Traumschiff Rework: Petra – Rafaela Mails — EN-UK
        // (Rafaela-Silva-Account: rafaela-silva@pronto-posto.com; Login rafaela-silva / Conrad3009)
        // Gleiches Muster wie die KS04-Sprachblöcke: eigener Datensatz je Sprache, eigene IDs,
        // Zeitstempel und Rätselwerte 1:1 aus dem DE-Satz. ID-Reservierung KS03:
        // DE 15–19 · EN 70–74 · FR 75–79 · IT 80–84 · ES 85–89.
        {
            id: 70,
            from: {
                email: 'p.whitfield@pronto-posto.com',
                name: 'Petra W',
                avatar: require('@src/assets/images/portrait/petra.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'rafaela-silva@pronto-posto.com'
            }],
            subject: 'St. Helen – new story?',
            cc: [],
            bcc: [],
            message: 'Hey Rafaela,<p>I heard at work that your fiancé has won tickets for the <b>St. Helen</b>.<br><br>Do you remember that piece on Helmsley I was working on a while back?<br>Have another look at it... You won\'t believe this, but back then my research threw up the name <b>Julian Hoffmann</b> as well.<br><br>And do you know who that is? <b>THE captain of the St. Helen.</b><br><br>Have a look at the <b>Atlantic Academy</b>. That\'s the college where the captain claims to have taken his degree...<br><br>I\'m not going to tell you to work through your holiday, but THAT would make a glorious story.<br><br>I\'m happy to help however I can, but please be careful about where and how you write your research down. People like that are always on their guard and very well connected.<br><br>Take care, and see you tomorrow,<br>Petra',
            attachments: [],
            isStarred: true,
            labels: ['work'],
            time: 'Tue. Jan. 31 2023 15:43:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },

        {
            id: 71,
            from: {
                email: 'p.whitfield@pronto-posto.com',
                name: 'Petra W',
                avatar: require('@src/assets/images/portrait/petra.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'rafaela-silva@pronto-posto.com'
            }],
            subject: 'Re: Old ship\'s ghost?',
            cc: [],
            bcc: [],
            message: 'Hey Rafaela,<p>Honestly, this <b>old ship\'s ghost</b> business sounds more like something for the gossip pages. We can\'t go publishing ghost stories!<br><br>Haven\'t you got anything on the captain or the crew?',
            attachments: [],
            isStarred: false,
            labels: ['work'],
            time: 'Mon. Mar. 06 2023 10:35:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 72,
                    from: {
                        email: 'rafaela-silva@pronto-posto.com',
                        name: 'Rafaela S',
                        avatar: require('@src/assets/images/portrait/rafaela.png').default
                    },
                    to: [{
                        name: 'Petra W',
                        email: 'p.whitfield@pronto-posto.com'
                    }],
                    subject: 'Old ship\'s ghost?',
                    cc: [],
                    bcc: [],
                    message: 'Hello Petra,<p>Of course I brought my notebook along. I keep the most important information in there – very old-fashioned, I know. It\'s with me practically all the time, so don\'t worry. Nobody is getting at it in a hurry ;) <br><br>But you were right, there is something odd about this ship. I\'ve jotted down a few notes:<br><br><b>Old ship\'s ghost?</b><br>- Petra says I shouldn\'t write about it, but I think there\'s more to it.<br>- Tobias says: the ghost lives in the cabin next to his. A woman with dark hair is always out in the corridor staring at that cabin, but she vanishes the moment anyone comes along. → When I spoke to her, she avoided me. Who is she? Maybe she knows something. <br>- Is Tobias just dreaming it? I don\'t know whether to believe it.<br><br><i>Thank you for worrying about me, Petra :)</i>',
                    attachments: [],
                    isStarred: false,
                    labels: ['work'],
                    time: 'Sun. Mar. 05 2023 20:24:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },

        {
            id: 73,
            from: {
                email: 'p.whitfield@pronto-posto.com',
                name: 'Petra W',
                avatar: require('@src/assets/images/portrait/petra.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'rafaela-silva@pronto-posto.com'
            }],
            subject: 'Re: More notes',
            cc: [],
            bcc: [],
            message: 'Rafaela, please be careful! If it gets too dangerous, just leave it!',
            attachments: [],
            isStarred: false,
            labels: ['work'],
            time: 'Thu. Mar. 09 2023 08:12:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 74,
                    from: {
                        email: 'rafaela-silva@pronto-posto.com',
                        name: 'Rafaela S',
                        avatar: require('@src/assets/images/portrait/rafaela.png').default
                    },
                    to: [{
                        name: 'Petra W',
                        email: 'p.whitfield@pronto-posto.com'
                    }],
                    subject: 'More notes',
                    cc: [],
                    bcc: [],
                    message: 'Hello Petra,<p>Yes... you\'re probably right about that. The crew are behaving strangely as well. I haven\'t got anything solid yet, but a few things have caught my eye:<br><br><b>The captain</b><br>- Interview 08/03, very unfriendly, dodges my questions.<br>- www.atlantic-academy.com<br>- Not one bad word about him from the crew, and he covers for them – they\'re all in it together (?!)<br>- I got hold of his card during the interview. The 01 should have access to every cabin. I only need it for a moment, then I\'ll let it turn up again. He won\'t notice a thing.<br><br><b>Other</b><br>- I keep feeling as if there\'s someone there every time I leave my cabin... am I being followed?<br>- Romy and Axel seem to be a couple<br>- Tobias says nobody will help him about the noise from the cabin next to his<br>- Axel and Romy want money for an interview → open to bribes??<br>- I wanted to find out what was going on with that woman, and I\'ve discovered something bad. I need to lie low for a while, this is getting too dangerous...<br><br>There are a few other things too, but I\'d rather only write those down on paper.',
                    attachments: [],
                    isStarred: false,
                    labels: ['work'],
                    time: 'Wed. Mar. 08 2023 21:03:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },
    ]
}

export function getSpam() {
    return [
        // KS03 Traumschiff Rework: Rafaela Spam Mails — EN-UK
        // (Rafaela-Silva-Account: rafaela-silva@pronto-posto.com)
        // ID-Reservierung KS03-Spam: DE 107–109 · EN 160–162 · FR 170–172 · IT 180–182 · ES 190–192.

        {
            id: 160,
            from: {
                email: 'offers@instant-crypto.pro',
                name: 'Instant Crypto Offers',
                avatar: require('@src/assets/images/portrait/crypto.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'rafaela-silva@pronto-posto.com'
            }],
            subject: 'EXCLUSIVE: Make 5000% in 3 Days!',
            cc: [],
            bcc: [],
            message: '<p>Hey,</p><p>You have been selected for our secret investment programme. Earn high returns in record time – start with as little as £100. Get in touch with our team to sign up.</p><br><p>Cheers,<br>Instant Crypto Offers</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Sat. Feb. 04 2023 12:12:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },

        {
            id: 161,
            from: {
                email: 'funnybiz@wonderworld.com',
                name: 'Wonderworld FunBiz',
                avatar: require('@src/assets/images/portrait/funbiz.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'rafaela-silva@pronto-posto.com'
            }],
            subject: 'Unbeleivable but Ture!!! 😜',
            cc: [],
            bcc: [],
            message: '<p>Hey Rafaela,</p><p>You wont beleive it, but we have got our super-duper mega offer running right now! 😎<br>Everyone who joins in now gets free unicorn stickers + a pack of unbeatable wonder sweets.</p><p>So dont wait to long or theyll be gone, quick as a flash! 🦄🍬<br>And psst… dont tell no one about my secret tipp, or its all over!</p><br><p>Lots of laughs,<br>The Wonderworld FunBiz Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Sat. Feb. 25 2023 09:51:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },

        {
            id: 162,
            from: {
                email: 'winner@superlotto-global.com',
                name: 'SuperLotto Global',
                avatar: require('@src/assets/images/portrait/superlotto.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'rafaela-silva@pronto-posto.com'
            }],
            subject: 'You\'re a winner!',
            cc: [],
            bcc: [],
            message: '<p>Congratulations, Rafaela!</p><p>You have been selected as the winner of our SuperLotto prize draw. To claim your prize, please contact our support team and have your details to hand. You have 48 hours to claim.</p><br><p>The SuperLotto Global Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Wed. Mar. 01 2023 10:24:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
    ]
}
